// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__DgzGU","previous":"Pagination_previous__ei0ok","next":"Pagination_next__gia39"};